<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('textblocks.create_textblock') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.textblock') }} <strong>{{ textblock.identifier }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
            <app-textblock-new *ngIf="newMode()"></app-textblock-new>
            <app-textblock-basedata *ngIf="editMode()" [textblock]="textblock" (setEdit)="setEdit($event)"></app-textblock-basedata>
          </p-tabPanel>

          <p-tabPanel header="{{ t('common.labels.contents') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('contents') || textblock === null">
            <app-content-editor *ngIf="editMode()" [owner]="textblock" [languages]="languages" [mode]="'textblocks'" (setEdit)="setEdit($event)"></app-content-editor>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
